import JwtService from '@core/auth/jwt/jwtService';


export const handleLogin = (data) => {

  const { jwtConfig } = JwtService()

  return (dispatch) => {

    dispatch({
      type: 'LOGIN',
      data,
      jwtConfig,
      [jwtConfig.storageTokenKeyName]: data[jwtConfig.storageTokenKeyName],
      [jwtConfig.storageRefreshTokenKeyName]:
        data[jwtConfig.storageRefreshTokenKeyName],
      [jwtConfig.storageClientKeyName]: data[jwtConfig.storageClientKeyName],
      [jwtConfig.storageUidName]: data[jwtConfig.storageUidName],
    });

    localStorage.setItem('userData', JSON.stringify(data));
    localStorage.setItem(jwtConfig.storageTokenKeyName, data.accessToken);
    localStorage.setItem(jwtConfig.storageClientKeyName, data.client);
    localStorage.setItem(jwtConfig.storageUidName, data.uid);
    localStorage.setItem('accountName', data.account.name);
    localStorage.setItem("subdomain", data.account.subdomain);

    localStorage.setItem(
      jwtConfig.storageRefreshTokenKeyName,
      JSON.stringify(data.refreshToken),
    );
  };
};

export const handleLogout = (jwtConfig) => {
  return (dispatch) => {
    dispatch({
      type: 'LOGOUT',
    });

    localStorage.removeItem('userData');
    localStorage.removeItem('accessToken');
    localStorage.removeItem('uid');
    localStorage.removeItem('client');

  };
};
